// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCheckSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PtoCheckSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoCheckSquareOutlined = function PtoCheckSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCheckSquareOutlinedSvg
  }));
};

PtoCheckSquareOutlined.displayName = 'PtoCheckSquareOutlined';
export default React.forwardRef(PtoCheckSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCheckSquareOutlined.js
// module id = 3879
// module chunks = 0